import {
  Plan,
  PlansPage,
  Page,
  PlansPageRequest,
  PlansDealBannerProps,
  PlansBanners,
  PlanFeatures,
  MockPlan,
  Deal,
} from '../types/plans';

import { PurchasePreview } from '../types/buy';
import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt';
import { faStethoscope } from '@fortawesome/pro-light-svg-icons/faStethoscope';
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt';
import { faEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faMobileAlt } from '@fortawesome/pro-light-svg-icons/faMobileAlt';
import { faHeadSideBrain } from '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import { faHandHoldingSeedling } from '@fortawesome/pro-light-svg-icons/faHandHoldingSeedling';
import { faComments } from '@fortawesome/pro-light-svg-icons/faComments';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faTags } from '@fortawesome/pro-light-svg-icons/faTags';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

import moment from 'moment/moment';
import { ComposerBlock } from '../types/composer';

export const CURRENCY_CODE_SYMBOL_MAP = {
  AUD: 'AU$',
  CAD: 'CA$',
  GBP: '£',
  INR: '₹',
  USD: '$',
  EUR: '€',
  SAR: 'SR',
  MXN: 'Mex$',
  ILS: '₪',
  EGP: 'E£',
  PHP: '₱',
  MYR: 'RM',
};

export const plansProduct: Plan[] = [
  {
    name: 'md-everything',
    product: 'md',
    data: '{"tools":[9,4,8,10,11,1]}',
    code: 'md-2_years',
    currency: {
      base: 598,
      currency: 'USD',
      setupFee: 0,
      unitAmount: 279,
    },
    hash: 'CZ722yq6RXegiOPxd_oDNEGpRFSicL61',
    intervalLength: 24,
    autoRenew: 1,
    description: 'Best Value',
    textColor: 'gray',
    backgroundColor: 'gray',
    billed: 'Billed every 2 years',
    link: '/buy?plan=md-2_years',
  },
  {
    name: 'md-everything',
    product: 'md',
    data: '{"tools":[9,4,8,10,11,1]}',
    code: 'md-1_year',
    currency: {
      base: 378,
      currency: 'USD',
      setupFee: 0,
      unitAmount: 199,
    },
    hash: 'jGJcTWqBQZGEfNjoy8niIvBfSWWBt8w4',
    intervalLength: 12,
    autoRenew: 1,
    description: 'Most popular',
    billed: 'Billed annually',
    link: '/buy?plan=md-1_year',
  },
  {
    name: 'md-everything',
    product: 'md',
    data: '{"tools":[9,4,8,10,11,1]}',
    code: 'md-6_months',
    currency: {
      base: 318,
      currency: 'USD',
      setupFee: 0,
      unitAmount: 179,
    },
    hash: 'Wev5eNCJRfylbRQsTn3TSac3SA_-Ge3d',
    intervalLength: 6,
    autoRenew: 1,
    textColor: 'gray',
    backgroundColor: 'gray',
    billed: 'Billed every 6 months',
    link: '/buy?plan=md-6_months',
  },
];

export const mockPurchasePreview: PurchasePreview = {
  status: 'purchase',
  plan: plansProduct[0],
  deal: undefined,
  subscriptionChangePreview: undefined,
  totalCharge: 279,
};

export const mockDeal: Deal = {
  url: 'buynow',
  dealID: 1126,
  caption: 'Save 50% on Osmosis Prime.',
  subcaption: 'Become a member today!',
  data: {
    version: 'a',
    campaign: 'Spring2024',
    timerEnabled: true,
    trialCTAEnabled: true,
    // books is optional, omit or add as needed
  },
  productSet: '',
  discountType: 'percent',
  discountAmount: 50,
  recurlyCouponID: 2,
  bookIncluded: 0,
  disclaimer:
    'Offer cannot be combined with any other promotion or discount, or applied retroactively.',
  starts: '2021-01-01T05:00:00.000Z',
  expires: '2031-12-31T05:00:00.000Z',
  status: 1,
  version: 'a',
  trialCTAEnabled: true,
  timerEnabled: true,
  // Remove fields not in Deal type (like notes, discount)
};

const block: ComposerBlock = {
  block: 'planSelector',
  args: {
    theme: 'green',
    heading: 'deals/getvisual',
    subheading: 'test',
    text: '<p>test</p>',
  },
  name: 'plan-selector',
  id: '3d0d9f8d-d340-4fcb-ac2d-c28447985e7d',
};

const blocks: ComposerBlock[] = Array(2).fill(block);

const Plans: Plan = {
  name: 'md-everything',
  product: 'md',
  data: '{"tools":[9,4,8,10,11,1]}',
  code: 'md-1_year',
  currency: {
    base: 2,
    currency: 'string',
    setupFee: 2,
    unitAmount: 2,
  },
  hash: 'wpjvW5M6Sb2qh4kyCsBE36fRSoacfhf8',
  intervalLength: 12,
  autoRenew: 1,
};

const page = {
  nodeID: 49191468,
  version: 'a',
  url: 'md',
  status: 'published',
  modified: '2023-05-25T21:02:42.000Z',
  product: 'MD',
  client: 'plansPage',
  template: 'plansPage',
  title: 'Best Way to Study for Medical School & USMLE | Osmosis',
  image:
    'https://d3cdo0emj8d2qc.cloudfront.net/assets/3800be6d2ddada94d64b161e67f637d496dd732e.png',
  description:
    'Dominate classes & USMLE prep with Osmosis, the best way to study in med school. Access 1200+ videos, high yield notes, study schedule & more. Try it free.',
  versionLabel: 'Switched hero and pricing blocks',
  content: {
    path: 'landing',
    blocks: blocks,
  },
};

// should be missing plans
export const composerPage: Page = {
  ...page,
  plans: plansProduct,
};

export const planApiData: Plan[] = Array(2).fill(Plans);

export const mockPlanApi: PlansPageRequest = {
  needsVisitorType: true,
  page: composerPage,
  localization: {
    'string.type': 'Unknown',
  },
  plans: planApiData,
  success: 1,
};

export const mockSuitePlan = {
  name: 'md-everything',
  product: 'md',
  data: '{"tools":[9,4,8,10,11,1]}',
  code: 'md_mdsuiteb2c-6_months',
  currency: {
    base: 518,
    currency: 'USD',
    setupFee: 0,
    unitAmount: 478,
    USDUnitAmount: 478,
  },
  hash: 'a6eKgVV3S2G08_3qgdNPILY3SX6u6lok',
  intervalLength: 6,
  productID: 44,
  autoRenew: 1,
};
export const mockBasicPlan = {
  name: 'md-everything',
  product: 'md',
  data: '{"tools":[9,4,8,10,11,1]}',
  code: 'md_mdbasscib2c-6_months',
  currency: {
    base: 318,
    currency: 'USD',
    setupFee: 0,
    unitAmount: 478,
    USDUnitAmount: 478,
  },
  hash: '3FwKcmTGSxK_SCmYoy3uufAiSsG5Vj1F',
  intervalLength: 6,
  productID: 49,
  autoRenew: 1,
};

export const mockPlansPage: PlansPage = {
  needsVisitorType: true,
  page: composerPage,
  plans: plansProduct,
};

export const mockDealBanner: PlansDealBannerProps = {
  deal: {
    url: 'deal',
    msg: 'deal',
    disclaimer: mockDeal.disclaimer,
    expires: moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
    caption: mockDeal.caption,
    subscription: mockDeal.subcaption,
  },
  schoolData: {
    nickname: 'Hopkins',
    name: 'Hopkins University',
  },
  dealPaused: false,
  isUserDeal: true,
  friendName: 'friendName',
};

export const plansFeaturesMD: PlanFeatures = {
  retention: [
    {
      icon: faYoutube,
      color: 'olive',
      text: `1,700+ videos including comprehensive coverage of:`,
      list: [
        'Foundational Sciences',
        'Organ Systems',
        'USMLE® Step 1 Review',
        'Clerkships',
        'USMLE® Step 2 Review',
      ],
    },
    {
      icon: faBolt,
      color: 'teal',
      text: `15,000+ flashcards on USMLE® Step 1 topics powered by spaced repetition`,
    },
    {
      icon: faStethoscope,
      color: 'blue',
      text: `2,700+ rigorously reviewed USMLE®-style questions`,
    },
    {
      icon: faFileAlt,
      color: 'red',
      text: `High-Yield Notes covering Pathology and Physiology`,
    },
  ],

  efficiency: [
    {
      color: 'red',
      text: `Create and share custom playlists of Osmosis videos, questions, and High-Yield Notes`,
    },
    {
      icon: faEdit,
      color: 'blue',
      text: `Timestamp and annotate videos so you don't forget high-yield information`,
    },
    {
      icon: faMobileAlt,
      color: 'lavender',
      text: `Study on the go with Osmosis mobile apps for iOS and Android`,
    },
  ],

  professionalDevelopment: [
    {
      icon: faHeadSideBrain,
      color: 'orange',
      text: `How to Learn in Medical School online course ($99 value)`,
    },
    {
      icon: faHandHoldingSeedling,
      color: 'red',
      text: `Explore Core Competencies like Interpersonal and communication skills, Learning science, Patient care, and Professionalism`,
    },
  ],

  benefits: [
    {
      icon: faComments,
      color: 'blue',
      text: `Round-the-clock customer support`,
    },
    {
      icon: faEnvelope,
      color: 'blue',
      text: `Personalized daily reminder emails to help you stay on track`,
    },
    {
      icon: faTags,
      color: 'orange',
      text: `Discounts on Osmosis swag and partner products`,
    },
  ],
};

export const heroBannerDataMD: PlansBanners[] = [
  {
    title: 'Where medical students become expert clinicians',
    subtitle: 'Dominate your medical school classes & the USMLE®',
    text: [
      'As a medical student, you’re inundated with so much information, it’s difficult to know what’s important. Osmosis provides you with the right study techniques to help you retain, understand, and study more efficiently throughout med school. Excel in your classes, ace the USMLE®, and be better prepared for clinicals when you learn by Osmosis.',
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/tqZOAaoaSfy_qBJrHwIotZMTTHuLggpZ.png',
    reverse: false,
  },
  {
    title: `Learn faster & retain more with Osmosis's comprehensive video library`,
    subtitle: 'Up-to-date, accurate information so you stay a step ahead',
    text: [
      'Over 1,700 videos',
      'Fun, short, and easy-to-digest',
      'Comprehensive coverage of Foundational Sciences, Organ Systems, USMLE® Step 1 Review, Clerkships, plus videos on essential topics for clerkships and USMLE® Step 2 CK Review',
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/qQ8STdjaTYCUNjxcHS1VUPpLQa_JxJDn.png',
    reverse: true,
  },
  {
    title: `Study on the go with Osmosis Mobile`,
    subtitle: 'Make the most of your time with our top-rated app',
    text: [
      'View Osmosis videos with aligned questions, flashcards, and study notes on the go',
      'Set playlists, download for offline use, dark mode, and more',
      'Available on iOS and Android',
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/qQ8STdjaTYCUNjxcHS1VUPpLQa_JxJDn.png',
    reverse: false,
  },
  {
    title: `Test your knowledge with flashcards powered by spaced repetition`,
    subtitle: 'Quiz yourself at optimal intervals for maximum retention',
    text: [
      'Over 15,000 flashcards written and reviewed by medical professionals',
      `Spaced repetition sends you specific flashcards at key intervals so you don't forget`,
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/FvpwAwFVQdG27Z0lLKi8-8ggTfSxbqu1.png',
    reverse: true,
  },
  {
    title: `Questions to ensure you’ve got things down`,
    subtitle:
      'Test your knowledge and feel more confident with USMLE®-style case questions',
    text: [
      '2,700+ rigorously reviewed USMLE®-style questions plus hundreds of additional recall questions with detailed answer explanations',
      `Includes detailed correct and incorrect answer explanations written and reviewed by health professionals`,
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/r9u4wI-lQgORQbGc9eHinvlrQOap9Sac.png',
    reverse: false,
  },
  {
    title: `High-Yield Notes so you focus on the important stuff`,
    subtitle: 'Summarize Pathology and Physiology, saving you time and stress',
    text: [
      '1,200+ beautifully illustrated notes with full-color images and tables',
      `Separated into pathology, symptoms, diagnosis, and treatment making it applicable to USMLE® Step 1`,
    ],

    imgSrc:
      'https://d3cdo0emj8d2qc.cloudfront.net/assets/HNNPnPG5ROuj9jhivTcLK4X_Q9iB6VFZ.png',
    reverse: true,
  },
];

export const mockPlanNew: MockPlan = {
  headers: [
    {
      id: '1',
      defaultMessage: ' ',
    },
    {
      id: '2',
      defaultMessage: 'Basic Sciences',
      tabColor: '#376D37', // TODO: move to colors
      price: '$xxx/yr',
    },
    {
      id: '3',
      defaultMessage: 'Clinical Sciences',
      tabColor: '#83690C',
      price: '$xx/yr',
    },
    {
      id: '4',
      defaultMessage: 'Osmosis Suite',
      tabColor: '#1A61B2',
      price: '$xxx/yr',
    },
  ],
};
